import { Copy, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCopyToClipboard } from "@/components/useCopyToClipboard";

interface CopyValueProps {
  value?: string;
  className?: string;
  showIcon?: boolean;
  timeout?: number;
  withToast?: boolean;
  children?: React.ReactNode;
}

export const CopyValue = ({
  value,
  className = "",
  showIcon = true,
  timeout = 2000,
  withToast = true,
  children
}: CopyValueProps) => {
  const { copy, isCopied } = useCopyToClipboard();

  const handleCopy = async () => {
    if (!value) {
      return;
    }

    await copy(value, { timeout, withToast });
  };

  if (!value) {
    return <span className={className}>-</span>;
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleCopy}
      animations="none"
      className={`h-auto p-0 font-normal text-foreground ${className} select-text cursor-pointer`}
    >
      <span className="flex items-center gap-1">
        {children || value}
        {showIcon &&
          (isCopied ? <Check className="text-green-500" /> : <Copy className="opacity-50" />)}
      </span>
    </Button>
  );
};

export const CopyIPAddress = CopyValue;
